const STATUS_TONES = {
    core: "border-transparent bg-accent text-white",
    future: "border-white/35 text-white/85",
    later: "border-white/20 border-dashed text-mist",
    longterm: "border-white/15 border-dashed text-cad",
};

export const StatusLabel = ({ tier, id, children }) => (
    <span
        data-testid={id}
        className={`inline-flex w-fit max-w-full flex-wrap items-center gap-2 border px-3 py-1.5 font-mono text-[13px] leading-snug tracking-[0.22em] ${STATUS_TONES[tier]}`}
    >
        {tier === "core" && <span className="h-1.5 w-1.5 shrink-0 bg-white" />}
        {children}
    </span>
);

const COLS = {
    2: "sm:grid-cols-2",
    3: "sm:grid-cols-2 lg:grid-cols-3",
};

export const TypesList = ({ types, idPrefix, cols = 2, className = "" }) => (
    <ul
        data-testid={`${idPrefix}-types`}
        className={`grid gap-x-10 ${COLS[cols]} ${className}`}
    >
        {types.map((t, i) => (
            <li
                key={t}
                className="flex items-baseline justify-between gap-4 border-b border-white/10 py-3"
            >
                <span className="text-[15px] leading-relaxed text-mist">{t}</span>
                <span className="font-mono text-[13px] tracking-[0.18em] text-cad">
                    {String(i + 1).padStart(2, "0")}
                </span>
            </li>
        ))}
    </ul>
);
